$(document).ready(function() {

  function OnWindowResize()
  {
      // user menu
    if (window.innerWidth >= 1200) {
      $("#dropdown-customer").appendTo(".header-panel-bt .customer-links");
      if ($(".close-menu-mb").is(".menu-open"))
      {
        $("html").removeClass("translate-overlay");
        $(".close-menu-mb").removeClass("menu-open");
      }
    } else {
      $("#dropdown-customer").appendTo("body");
    }
  }


  // user menu
  $("[data-dropdown-user]").click(function(e) {
    if (window.innerWidth >= 1200)
    {
      e.preventDefault();
      e.stopPropagation();
      $(this).siblings("#dropdown-customer").slideToggle();
    }
  });

  $(document).click(function (e) {
    if (!$(e.target).closest("[data-dropdown-user], #dropdown-customer").length) {

      if (window.innerWidth >= 1200)
      {
        $("#dropdown-customer").slideUp();
      }
      else
      {
        $("#dropdown-customer").slideUp();
      }
    }
  });
  
  setTimeout(()=>{
    OnWindowResize();
  },0);

  $(window).resize(() => {
    OnWindowResize();
  });

  setTimeout(()=>{
    // mobile menu
    let iconNav = $("[data-menu-mb-toogle]");
    iconNav.click(function(e) {
      if (iconNav.is(":visible")) 
      {
          e.preventDefault();
          e.stopPropagation();
  
          $("html").toggleClass("translate-overlay");
          $(".close-menu-mb").toggleClass("menu-open");
          
          $(".jas-mb-style").css({
            overflow: ""
          });
          $(".site-nav")
            .find("[data-toggle-menu-mb]")
            .parent()
            .next(".sub-menu-mobile")
            .removeClass("sub-menu-open");
     }
    });

    $(".wrapper-overlay").click(() => {
      if ($("[data-menu-mb-toogle]").is(":visible") && $(".close-menu-mb").hasClass("menu-open"))
        $(".close-menu-mb").click();
    });
  });
  
  setTimeout(()=>{
    // mobile menu - open
    $(".site-nav .dropdown > a").click(function (e) {
      if (window.innerWidth < 1200) {
        if ($(this).next(".sub-menu-mobile").length == 0)
          return;
        e.preventDefault();
        let curMenu = $(this).next(".sub-menu-mobile");
        if ($(".site-header .header-mb").is(":visible")) {
          if (curMenu.hasClass("sub-menu-open")) {
            curMenu.removeClass("sub-menu-open");
          } else {
            curMenu.addClass("sub-menu-open").css({
              overflow: ""
            });
            $(".main-menu.jas-mb-style").animate(
              {
                scrollTop: 0,
              },
              0
            );
            $(".main-menu.jas-mb-style").css({
              overflow: "hidden",
            });
          }
        }
      }
    });
  });

  setTimeout(()=>{
    if (window.innerWidth < 1200) {
      // mobile menu - close
       $(".sub-menu-mobile .menu-mb-title")
          .click(function (e) {
            e.preventDefault();
            e.stopPropagation();
    
            if ($(this).parent().hasClass("bg")) {
              $(this).parent().parent().removeClass("sub-menu-open");
            } else {
              $(this).parent().removeClass("sub-menu-open");
            }
    
            if (!$(this).closest(".menu-lv-2").length) {
              $(".main-menu.jas-mb-style").css({
                overflow: "",
              });
            }
          });
    
      $(".menu__mobile .menu__mobile").on("click", function (e) {
        //e.stopPropagation();
      });
    }
  });
});